export default function getSessionEndDate({
  startDate,
  durationMinutes,
}: {
  startDate: Date
  durationMinutes: number
}): Date {
  return new Date(durationMinutes * 60 * 1000 + startDate.getTime())
}
